import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import { NumberFormatter } from '@repo/toolkit/number'
import Badge from '@repo/ui/badge'
import DataTable from '@repo/ui/data-table'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getTeachingHallAssignments } from '../../../api/ols/get-teaching-hall-assignments'
import { getTranslatedName } from '../../../lib/utils/functions/translation.functions'

type Props = {
  olId: number
  teachingHallId: number
}

export function TeachingHallAssignmentHistory({ olId, teachingHallId }: Props) {
  const { data } = useQuery({
    queryKey: ['teaching-hall-assignments', teachingHallId],
    queryFn: () => getTeachingHallAssignments({ olId, teachingHallId }),
    enabled: !!teachingHallId
  })

  return (
    <div>
      <InnerBox className="rounded-xl gap-3">
        <div className="flex flex-row gap-3 items-center">
          <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
            History of Assignments
          </Typography>
        </div>

        <DataTable
          columns={[
            {
              accessorKey: 'from',
              header: 'From',
              enableSorting: true,
              cell: ({ row }) => <Badge text={DateFormatter.DDMMYYYY(row.original.from)} />
            },
            {
              accessorKey: 'to',
              header: 'To',
              enableSorting: true,
              cell: ({ row }) => <Badge text={DateFormatter.DDMMYYYY(row.original.to)} />
            },
            {
              accessorKey: 'formulas',
              header: 'Programme',
              cell: ({ row }) =>
                row.original.formulas
                  .map((formula) => getTranslatedName(formula, 'en') || '—')
                  .join(', ')
            },
            {
              accessorKey: 'pricePerDay',
              header: 'Price per day',
              enableSorting: true,
              cell: ({ row }) =>
                row.original.pricePerDay != null
                  ? NumberFormatter.formatCurrency(row.original.pricePerDay, row.original.currency)
                  : '-'
            }
          ]}
          data={data ?? []}
          paginated={false}
          rowCount={0}
          manualSorting={false}
        />
      </InnerBox>
    </div>
  )
}
